import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
    return (
        <section id='services' >
            <h5>What I Offer</h5>
            <h2>Services</h2>

            <div className='container services_container'>
                <article className='service'>
                    <div className='service__head'>
                        <h3> App Creation </h3>
                    </div>

                    <ul className='service__list'> 
                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Identify and plan for new features.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Develop application programming interfaces (APIs) to support mobile functionality.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Remain up to date with the terminology, concepts and best practices for coding mobile apps.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Use and adapt existing web applications for apps.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Communicate with users to understand their needs and experiences.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Write unit and UI tests to identify malfunctions.</p>
                        </li>

                    </ul>

                </article>

                <article className='service'>
                    <div className='service__head'>
                        <h3> Web Development </h3>
                    </div>

                    <ul className='service__list'>
                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Writing well designed, testable, efficient code by using best software development practices.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Integrating data from various back-end services and databases.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Gather and refine specifications and requirements based on technical needs.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Cooperate with web designers to match visual design intent.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p>Create website layout/user interface by using standard HTML/CSS practices.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Top-notch programming skills and in-depth knowledge of modern HTML/CSS.</p>
                        </li>

                        <li>
                            <BiCheck className='service__list-icon' />
                            <p> Aggressive problem diagnosis and creative problem solving skills.</p>
                        </li>
                    </ul>

                </article>
            </div>
        </section>
    )
}

export default Services